module.exports = __webpack_public_path__ + "static/img/img_select.a7903ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/regionTutorialIos/img_select.png
// module id = 1109
// module chunks = 1